var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBunkerActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 12,
    viewBox: "0 0 39 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4718 0.00590052C30.1717 -0.0802941 38.5269 0.729935 38.6418 5.62579C38.7682 11.0963 29.4592 11.2572 22.2648 11.0905C12.4674 10.8722 1.21608 7.80938 0.153013 5.08563C-1.38125 1.14941 8.82994 0.132319 21.4718 0.00590052Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.276 9.19097C17.7422 9.08753 12.674 8.35775 8.36423 7.18551C3.3592 5.82363 1.65829 4.49624 1.45717 3.98481C1.31352 3.61705 1.37672 3.41593 1.52038 3.23205C1.89389 2.74936 3.22129 1.84144 7.96199 1.20935C11.2489 0.772628 15.662 0.537028 21.4658 0.473819C21.6037 0.473819 21.7397 0.473819 21.8738 0.473819C26.8214 0.439341 30.4588 0.743896 32.9872 1.40472C36.7625 2.38734 37.2279 3.88713 37.2509 4.93296C37.2739 5.78916 36.9923 6.47871 36.389 7.04185C34.1192 9.16798 27.7063 9.21395 25.6032 9.22544C24.6378 9.23119 23.5805 9.2197 22.276 9.19097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunkerActiveIcon);
export default __webpack_public_path__ + "static/media/bunkerActiveIcon.483733905fa4e268223ff4b1932dcffd.svg";
export { ForwardRef as ReactComponent };